module.exports = __webpack_public_path__ + "static/apple-icon-180x180-63f62b4ab84720aebe1a9b5275b88562.png";